<template>
  <section class="ccui-app-main" v-loading="pageLoading">
    <!--    <transition name="fade-transform" mode="out-in">-->
    <!-- <keep-alive> -->
    <router-view :key="key" />
    <!-- </keep-alive> -->
    <!--    </transition>-->
  </section>
</template>

<script>
export default {
  name: "AppMain",
  computed: {
    key() {
      return this.$route.fullPath;
    },
    pageLoading() {
      return this.$store.state.app.pageLoading.pageLoadingStatus;
    }
  },
  watch: {
    /*$route() {
      this.$store.dispatch("setPageLoadingEnable", false);
      this.$store.dispatch("setPageLoading", true);
    }*/
  }
};
</script>

<style scoped>
.app-main {
  /*84 = navbar + tags-view = 50 +34 */
  min-height: calc(100vh - 160px);
  /*width: 100%;*/
  margin-left: 201px;
  position: relative;
  /*overflow: hidden;*/
}

@media print {
  .app-main {
    margin-left: 0;
  }
}
</style>
